// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1Qx8vC9j clearfix","pic":"pic-373LYN_d","text":"text-36pGXzq9","detail":"detail-2bdPGLgP"};